import React from "react";
import AppConfig from "util/AppConfig";
import { Badge } from "components/bootstrap";
const DevelopmentHeaderBadge = ({ smallScreen = false }) => {
  const smallScreenClass = smallScreen ? "small-scrn-badge" : "";
  return AppConfig.gl2DevMode() ? /* @__PURE__ */ React.createElement(Badge, { className: `${smallScreenClass} dev-badge`, bsStyle: "danger" }, AppConfig.isCloud() ? String.fromCharCode(9928) : "", " DEV") : null;
};
export default DevelopmentHeaderBadge;
